module.exports = __webpack_public_path__ + "static/media/world.43a0c20b.png";